import { beatAriadne } from "../ariadne/report";
import type { GraphIdentity } from "../services/dataLoader";
import type { TrackedEvent } from "../services/TelemetryService";
import { gameModeOf, type GameReport } from "../utils/gameReportUtils";

/** The shared contract spells a give-up "gave_up"; reports say "given_up". */
export const telemetryOutcome = (
  status: GameReport["status"],
): TrackedEvent["outcome"] => (status === "won" ? "won" : "gave_up");

/** The game_completed event for a finished game on the loaded graph. */
export function buildGameCompletedEvent(
  report: GameReport,
  result: GameReport["status"],
  playerPath: string[],
  graph: { version: string | null; identity: GraphIdentity | null },
): TrackedEvent {
  const event: TrackedEvent = {
    event_type: "game_completed",
    timestamp: Date.now(),
    game_type: gameModeOf(report),
    graph_id: graph.version ?? "unknown",
    // Par: the gold path's hops (Ruling R10; least-distance-route hops before the cutover).
    difficulty: report.optimalPath.length - 1,
    start_word: report.startWord,
    target_word: report.targetWord,
    player_path: playerPath,
    backtrack_count: report.backtrackEvents?.length || 0,
    move_accuracy: report.moveAccuracy || 0,
    outcome: telemetryOutcome(result),
    duration_ms: report.startTime ? report.timestamp - report.startTime : 0,
    ariadne_path: report.ariadne ? (report.aiPath ?? []) : [],
    ariadne_steps: report.ariadne?.moves ?? 0,
    player_beat_ariadne:
      !!report.ariadne && beatAriadne(report.ariadne.verdict),
    session_game_number: 0,
    lifetime_game_number: 0,
  };
  if (graph.identity) {
    event.vocab_hash = graph.identity.vocabHash;
    event.graph_hash = graph.identity.graphHash;
  }
  if (report.ariadne) {
    event.ariadne_engine = "v2-nb";
    event.ariadne_games = report.ariadne.games;
    event.ariadne_outcome = report.ariadne.verdict;
    event.ariadne_hash = report.ariadne.hash;
  }
  return event;
}
